import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import moment from "moment";
import { API_DATE_FORMAT } from "../../../../app_constants.js";
import { AVERAGE_OPTIONS, DEFAULT_GROUP, USER_ACCESS, API_STORE, API_NETWORK } from "../../constants";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_DETAILS_MODAL_LOADING = "saga/SET_DETAILS_MODAL_LOADING";
export const SET_HEAT_MAP_LOADING = "saga/SET_HEAT_MAP_LOADING";
export const SET_DATA_POINTS_LOADING = "saga/SET_DATA_POINTS_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLE_DATA_LOADING = "saga/SET_TABLE_DATA_LOADING";
export const SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS =
  "saga/SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS";
export const SET_CLASS_FILTERS_LOADING = "saga/SET_CLASS_FILTERS_LOADING";
export const SET_STAFF_FILTERS_LOADING = "saga/SET_STAFF_FILTERS_LOADING";
export const SET_PRIMARY_FILTER = "saga/SET_PRIMARY_FILTER";
export const SET_DATES_FOR_FUTURE_BOOKING = "saga/SET_DATES_FOR_FUTURE_BOOKING";
export const SET_BOOKING_STATUS_FILTERS_LOADING = "saga/SET_BOOKING_STATUS_FILTERS_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const SET_AVERAGE = "sagas/SET_AVERAGE";
export const SET_AVERAGE_GROUP = "sagas/SET_AVERAGE_GROUP";
export const SET_AVERAGE_LOCATIONS = "sagas/SET_AVERAGE_LOCATIONS";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_GRAPH_SUCCESS = "saga/FETCH_GRAPH_SUCCESS";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_DETAILS_MODAL_DATA = "saga/FETCH_DETAILS_MODAL_DATA";
export const FETCH_MODAL_DATA_SUCCESS = "saga/FETCH_MODAL_DATA_SUCCESS";
export const FETCH_DATA_POINTS_SUCCESS = "saga/FETCH_DATA_POINTS_SUCCESS";

export const UPDATE_FILTERS_BY_STAFF_SUCCESS = "saga/UPDATE_FILTERS_BY_STAFF_SUCCESS";
export const UPDATE_FILTERS_BY_CLASS_SUCCESS = "saga/UPDATE_FILTERS_BY_CLASS_SUCCESS";
export const UPDATE_CLASS_FILTERS = "saga/UPDATE_CLASS_FILTERS";
export const UPDATE_STAFF_FILTERS = "saga/UPDATE_STAFF_FILTERS";
export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_DATA_BY_STAFF = "saga/UPDATE_DATA_BY_STAFF";
export const UPDATE_DATA_BY_CLASS = "saga/UPDATE_DATA_BY_CLASS";
export const UPDATE_CATEGORY_FILTER = "saga/UPDATE_CATEGORY_FILTER";
export const UPDATE_GROUP_BY_FILTER = "saga/UPDATE_GROUP_BY_FILTER";
export const UPDATE_FUTURE_BOOKINGS = "saga/UPDATE_FUTURE_BOOKINGS";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/UPDATE_PERIOD_TYPE";
export const UPDATE_PERIOD_TYPE_SELECTED = "sagas/UPDATE_PERIOD_TYPE_SELECTED";
export const UPDATE_BOOKING_STATUS_FILTER = "sagas/UPDATE_TYPE_FILTER";

export const YEAR_OVER_YEAR_LOADING = "sagas/YEAR_OVER_YEAR_LOADING";
export const RESET_BOOKING_STATUS_FILTER_SELECTED = "sagas/RESET_BOOKING_STATUS_FILTER_SELECTED";
export const RESET_DETAILS_MODAL_DATA = "saga/RESET_DETAILS_MODAL_DATA";
export const RESET_CATEGORY_FILTER = "saga/RESET_CATEGORY_FILTER";
export const RESET_FILTERS = "saga/RESET_FILTERS";
export const CHANGE_TOGGLE = "sagas/CHANGE_TOGGLE";
export const CHANGE_TOGGLE_SUCCESS = "sagas/CHANGE_TOGGLE_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getTableData: createAction(FETCH_TABLE_DATA),
  updateCategory: createAction(UPDATE_CATEGORY_FILTER),
  updateStaff: createAction(UPDATE_STAFF_FILTERS),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDataByStaff: createAction(UPDATE_DATA_BY_STAFF),
  updateDataByClass: createAction(UPDATE_DATA_BY_CLASS),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateBookingStatus: createAction(UPDATE_BOOKING_STATUS_FILTER),
  fetchModalDetailsData: createAction(FETCH_DETAILS_MODAL_DATA),
  setAverage: createAction(SET_AVERAGE),
  setAverageGroup: createAction(SET_AVERAGE_GROUP),
  setAverageLocations: createAction(SET_AVERAGE_LOCATIONS),
  setSubAverageSelectedOptions: createAction(SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS),
  updateGroupBy: createAction(UPDATE_GROUP_BY_FILTER),
  updateFutureBookings: createAction(UPDATE_FUTURE_BOOKINGS)
};

export default function* watchUtilization() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchModalTableData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(FETCH_DETAILS_MODAL_DATA, fetchDetailsModalData);
  yield takeLatest(UPDATE_DATA_BY_STAFF, updateDataByStaff);
  yield takeLatest(UPDATE_DATA_BY_CLASS, updateDataByClass);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_DATES, updateDates);
  yield takeLatest(UPDATE_PERIOD_TYPE, updatePeriodTypeAndLoad);
  yield takeLatest(UPDATE_GROUP_BY_FILTER, fetchHeatMapChart);
  yield takeLatest(UPDATE_FUTURE_BOOKINGS, updateFutureBookings);
}

function getIds(data) {
  let ids = "";
  data.forEach((item, index) => {
    ids += item.id;
    if (index < data.length - 1) {
      ids += ",";
    }
  });
  return ids;
}

function* updateFutureBookings({ payload }) {
  payload ? yield setDatesForFutureBookings() : yield setDates();
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
  yield put({ type: SET_BOOKING_STATUS_FILTERS_LOADING, payload: true });

  const showNetworkAverages = yield select(
    (state) => state.utilization.currentUser.showNetworkAverages
  );

  if (showNetworkAverages && payload) {
    yield put({
      type: SET_AVERAGE,
      payload: AVERAGE_OPTIONS[0]
    });
  }
  try {
    yield fetchFilters();
    yield put({
      type: RESET_BOOKING_STATUS_FILTER_SELECTED
    });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    yield put({ type: SET_BOOKING_STATUS_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function* setDatesForFutureBookings() {
  const startDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  const hourlyImport = yield select((state) => state.utilization.currentUser.hourlyImport);
  const currentDate = hourlyImport
    ? startDate
    : moment(startDate).add(1, "days").format(API_DATE_FORMAT);
  const endDate = moment(currentDate).add(14, "days").startOf("day").format(API_DATE_FORMAT);
  const maxDate = moment(currentDate).add(30, "days").startOf("day").format(API_DATE_FORMAT);
  yield put({
    type: SET_DATES_FOR_FUTURE_BOOKING,
    payload: {
      selectedRequestDates: {
        startDate: currentDate,
        endDate
      },
      minDate: currentDate,
      maxDate
    }
  });
}

function* updatePeriodTypeAndLoad(payload) {
  yield put({ type: UPDATE_PERIOD_TYPE_SELECTED, payload: payload.payload });
  yield put({ type: YEAR_OVER_YEAR_LOADING, payload: true });
  try {
    yield fetchBreakdown();
    yield put({ type: YEAR_OVER_YEAR_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function* updateCustomRange() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function* updateDataByStaff(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if (filters.staff_values.length !== payload.payload.length && primaryFilter !== "class") {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "staff" });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else if (filters.staff_values.length === payload.payload.length && primaryFilter === "staff") {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
  }
}

function* updateDataByClass(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if (filters.class_values.length !== payload.payload.length && primaryFilter !== "staff") {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "class" });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else if (filters.class_values.length === payload.payload.length && primaryFilter === "class") {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.warn(error);
    }
  } else {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
  }
}

function* updateDates() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  try {
    yield fetchFilters();
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function* getCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: data.payload.currentUser, numberOfMonths: data.payload.numberOfMonths }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield put({
    type: RESET_FILTERS
  });

  yield setDates();

  if (data.payload.currentUser.showNetworkAverages) {
    yield put({
      type: SET_AVERAGE,
      payload: AVERAGE_OPTIONS[0]
    });
  }

  try {
    yield fetchFilters();
    const allSagas = [fetchHeatMapChart(), fetchBreakdown(), fetchDataPoints()];
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (error) {
    console.warn(error);
  }
}

function* getLocationParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  return {
    organization_id: organization_id.toString(),
    short_url
  };
}

function* getDateParams() {
  const {
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => state.utilization);

  return {
    start_date: startDate,
    end_date: endDate
  };
}

function* getCommonApiParams() {
  let locations = yield getLocationParams();
  let dates = yield getDateParams();
  return {
    ...locations,
    ...dates
  };
}

function* getAverageParams() {
  const { average, averageGroup, selectedSubAverageFilterOptions, selectedAverageLocations } =
    yield select((state) => state.utilization);

  if (!average || average === AVERAGE_OPTIONS[0])
    return { average_type: average, averages_object_ids: "" };

  if (average === USER_ACCESS) {
    return {
      average_type: API_STORE,
      averages_object_ids: getIds(selectedAverageLocations) || undefined
    };
  }

  if (averageGroup === DEFAULT_GROUP) {
    return { average_type: API_NETWORK };
  }

  return {
    average_type: averageGroup,
    averages_object_ids: getIds(selectedSubAverageFilterOptions) || undefined
  };
}

function* getApiParams() {
  const {
    selectedClassFilters,
    selectedStaffFilters,
    selectedCategoryFilters: { name },
    future_bookings,
    selectedBookingStatuses
  } = yield select((state) => state.utilization);

  const common = yield getCommonApiParams();
  const averageParams = yield getAverageParams();
  const params = {
    common,
    category_type: name.toString(),
    ...averageParams,
    future_bookings,
    visit_statuses: getIds(selectedBookingStatuses)
  };
  if (selectedClassFilters.length) {
    params.class_id = getIds(selectedClassFilters);
  }
  if (selectedClassFilters.length) {
    params.staff_id = getIds(selectedStaffFilters);
  }
  return params;
}

function* updateData() {
  yield put({ type: RESET_DETAILS_MODAL_DATA });
  const allSagas = [fetchHeatMapChart(), fetchBreakdown(), fetchDataPoints()];

  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield all(allSagas);
  } catch (error) {
    console.warn(error);
  }
}

const baseUrl = queryParams.apiVersion + "pages/attendance/utilization_chart";

const apiRequest = (urn, params) => axios({ method: "post", url: baseUrl + urn, data: params });

const utilizationApi = {
  getFilters: (params) => apiRequest("/get_filters", params),
  getHeatmap: (params) => apiRequest("/utilization_heatmap", params),
  getDataPoints: (params) => apiRequest("/data_points", params),
  getBreakdown: (params) => apiRequest("/breakdown", params),
  getClassesInfo: (params) => apiRequest("/classes_info", params),
  getDetailsModal: (params) => apiRequest("/utilization_details", params)
};

function* fetchUtilizationData({ apiMethod, successType, loadingType, additionalParams = {} }) {
  const { common, ...rest } = yield getApiParams();
  if (!rest.class_id) return;

  yield put({ type: loadingType, payload: true });
  try {
    const response = yield call(apiMethod, {
      ...common,
      ...rest,
      ...additionalParams
    });
    yield put({ type: successType, payload: response.data });
    yield put({ type: loadingType, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchBreakdown() {
  const periodType = yield select((state) => state.utilization.periodType);

  yield call(fetchUtilizationData, {
    apiMethod: utilizationApi.getBreakdown,
    successType: FETCH_GRAPH_SUCCESS,
    loadingType: YEAR_OVER_YEAR_LOADING,
    additionalParams: { period_type: periodType.toLowerCase() }
  });
}

function* fetchDataPoints() {
  yield call(fetchUtilizationData, {
    apiMethod: utilizationApi.getDataPoints,
    successType: FETCH_DATA_POINTS_SUCCESS,
    loadingType: SET_DATA_POINTS_LOADING
  });
}

function* fetchHeatMapChart() {
  const { common, ...rest } = yield getApiParams();
  if (!rest.class_id) return;
  const selectedGroupByFilterOption = yield select(
    (state) => state.utilization.selectedGroupByFilterOption
  );
  yield put({ type: SET_HEAT_MAP_LOADING, payload: true });

  try {
    const response = yield call(utilizationApi.getHeatmap, {
      ...common,
      ...rest,
      group_by: selectedGroupByFilterOption.id
    });

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data });
    yield put({ type: SET_HEAT_MAP_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchModalTableData(payload) {
  yield put({ type: SET_TABLE_DATA_LOADING, payload: true });

  const {
    common,
    category_type,
    average_type,
    future_bookings,
    visit_statuses,
    staff_id,
    class_id
  } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getClassesInfo, {
      ...common,
      tableDataUid: payload.payload.tableDataUid,
      category_type,
      average_type,
      future_bookings,
      visit_statuses,
      staff_id,
      class_id
    });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  let params = yield getCommonApiParams();
  const { future_bookings } = yield select((state) => state.utilization);

  try {
    const response = yield call(utilizationApi.getFilters, { ...params, future_bookings });

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchDetailsModalData({ payload }) {
  yield put({ type: SET_DETAILS_MODAL_LOADING, payload: true });
  const { common, ...rest } = yield getApiParams();
  if (!rest.class_id) return;

  try {
    const response = yield call(utilizationApi.getDetailsModal, {
      ...common,
      ...rest,
      utilization_type: payload.modalKey
    });
    yield put({ type: FETCH_MODAL_DATA_SUCCESS, payload: { [payload.modalKey]: response.data } });
    yield put({ type: SET_DETAILS_MODAL_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateFiltersByStaff() {
  let { common, staff_id, future_bookings } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, {
      ...common,
      staff_id,
      future_bookings
    });
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, error });
  }
}

function* updateFiltersByClass() {
  let { common, class_id, future_bookings } = yield getApiParams();

  try {
    const response = yield call(utilizationApi.getFilters, {
      ...common,
      class_id,
      future_bookings
    });
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, error });
  }
}

function* setDates() {
  const endDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}
